import React from 'react';
import { useIntl } from 'react-intl';
import {
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  Error as ErrorIcon,
  Help as HelpIcon,
} from '@mui/icons-material';

const STATUS_CONFIG = {
  0: { icon: HelpIcon, labelKey: 'noInspections', defaultLabel: 'No Inspections', className: 'unknown' },
  1: { icon: CheckCircleIcon, labelKey: 'noDefects', defaultLabel: 'No Defects', className: 'ok' },
  2: { icon: WarningIcon, labelKey: 'warning', defaultLabel: 'Warning', className: 'warning' },
  3: { icon: WarningIcon, labelKey: 'defectsFound', defaultLabel: 'Defects Found', className: 'warning' },
  4: { icon: ErrorIcon, labelKey: 'criticalDefects', defaultLabel: 'Critical Defects', className: 'critical' },
};

const StatusIcon = ({ status, showLabel = false }) => {
  const { messages } = useIntl();
  const config = STATUS_CONFIG[status] || STATUS_CONFIG[0];
  const IconComponent = config.icon;
  const label = messages[config.labelKey] || config.defaultLabel;

  return (
    <span className={`status-icon ${config.className}`}>
      <IconComponent fontSize="small" />
      {showLabel && <span>{label}</span>}
    </span>
  );
};

export default StatusIcon;
